export class UpdateProfile {
	"firstname" : "";
	"lastname" : "";
	"fullname" : "";
	"dob" : any;
	"age" : any;
	"email" : "";
	"phone" : "";
	"gender":"";
	"_id":"";

 }